import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import moment from 'moment';
import _ from 'lodash';

export function customerListStart() {
  pushClevertapEvent('Customer Start');
}

export function customerListExport() {
  pushClevertapEvent('Customer Export');
}

export function customerListImport() {
  pushClevertapEvent('Customer Import');
}

export function customerListSelect({ customer }) {
  pushClevertapEvent('Customer List Select', {
    'Customer Name': customer.name,
    'Customer Address': customer.address,
    'Customer Phone': customer.phone,
    'Customer Email': customer.email,
    'Customer Birthday': customer.birthday,
    'Customer Total Transactions': customer.orders,
    'Customer Lifetime Amount': customer.lifetime_total,
    'Customer Average Amount': customer.average_amount,
    'Customer Since': customer.member_since,
    'Customer Last Visit': customer.last_visit,
  });
}

export function customerListSelectPurchaseHistoryInvoice({ invoice }) {
  pushClevertapEvent('Customer List Select Purchase History Select', {
    'Customer Name': invoice.customer_name,
    'Customer Phone': invoice.customer_phone,
    'Customer Email': invoice.customer_email,
    'Transaction Date': moment(invoice.created_at).format('YYYY-MM-DD'),
    'Transaction Time': moment(invoice.created_at).format('hh:mm:ss'),
    'Receipt Number': invoice.invoice_no,
    'Served By': invoice.served_by ? invoice.served_by : '',
    'Collected By': invoice.collected_by,
    Total: invoice.total_collected,
    'Payment Method': _.uniq(
      invoice.payment_records.map(pr => pr.payment_type)
    ),
    'Payment Amount': invoice.total_amount_received,
    'Payment Note': invoice.payment_note ? invoice.payment_note : '',
  });
}

export function customerListSelectPurchaseHistoryTransaction({
  transaction,
  customer,
}) {
  pushClevertapEvent('Customer List Select Purchase History Select', {
    'Customer Name': customer.name,
    'Customer Phone': customer.phone,
    'Customer Email': customer.email,
    'Transaction Date': moment(transaction.created_at).format('YYYY-MM-DD'),
    'Transaction Time': moment(transaction.created_at).format('hh:mm:ss'),
    'Receipt Number': transaction.payment_no,
    'Served By': transaction.served_by ? transaction.served_by : '',
    'Collected By': transaction.collected_by,
    Total: transaction.total_collected,
    'Payment Method': transaction.payment_type,
    'Payment Amount': transaction.tendered,
    Change: transaction.change,
    'Payment Note': transaction.payment_note ? transaction.payment_note : '',
  });
}

export function loyaltyBannerClick() {
  pushClevertapEvent('Customer Find Out Loyalty');
}
